import React, { useState, useMemo } from 'react';
import { Grid } from '@material-ui/core';
import BreadCrumbs from '../../../../Core/Controls/Breadcrumb';
import ReportGijgoGrid from '../../../internal/ReportsScreens/GijgoForReportsScreen';
import { SquareButton } from '../../../../Core/FormInput/AppButton';
import { Add } from '@material-ui/icons';
import EditIcon from '@material-ui/icons/Edit';
import ReactDOM from 'react-dom';
import DialogComp from '../../../../Core/Modal/dialogModal';
import AddUpdateHolidayTypeModal from './addUpdateHolidayType';

let styleObj = {
    backgroundColor: '#183B68',
    borderRadius: '20%',
    width: '32px',
    height: '32px',
    textAlign: 'center',
    padding: '0px 0px 0px 0px'
};

const crumbs = [
    { name: 'Home', path: '/' },
    { name: 'Holiday Type', path: '/', active: true }
];

const HolidayType = () => {
    const [state, setState] = useState({
        isReload: new Date(),
        showModal: false,
        selectedUserHolidayTypeID: null
    });
    const handleClose = (shouldReload) => {
        setState((st) => ({
            ...st,
            showModal: false,
            selectedUserHolidayTypeID: null,
            isReload: shouldReload ? new Date() : st.isReload
        }));
    };

    const baseColumns = [
        {
            field: 'action',
            title: `Action`,
            filterable: false,
            sortable: false,
            width: '2%'
        },
        {
            field: 'tCardUserHolidayTypeDescription',
            title: `Holiday Type Description`,
            filterable: true,
            sortable: true,
            width: '10%'
        }
    ];

    const handelAddUpdate = (row = null) => {
        setState((st) => ({
            ...st,
            showModal: true,
            selectedUserHolidayTypeID: row ? row.tCardUserHolidayTypeID : null
        }));
    };
    const addButton = () => {
        const spn = document.createElement('span');
        const lnk = (
            <Grid container justifyContent="center" style={{ marginLeft: '5px' }}>
                <abbr title="Add">
                    <SquareButton style={styleObj} onClick={() => handelAddUpdate(null)}>
                        <Add fontSize="small" style={{ color: 'white' }} />
                    </SquareButton>
                </abbr>
            </Grid>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };

    const editButton = () => (value, record) => {
        const spn = document.createElement('span');
        const lnk = (
            <Grid container justifyContent="space-evenly">
                <abbr title="Edit">
                    {' '}
                    <SquareButton style={styleObj} onClick={() => handelAddUpdate(record)}>
                        <EditIcon fontSize="small" style={{ color: 'white' }} />
                    </SquareButton>
                </abbr>
            </Grid>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };

    const columns = useMemo(() => {
        const tempCols = [...baseColumns];
        let actionCol = tempCols.find((element) => element.field === 'action');

        if (actionCol) {
            actionCol.renderer = editButton({});
        }

        return tempCols;
    }, []);
    const rowDataStyle = (record) => {
        return {
            ['background-color']: record.tCardUserHolidayTypeBackColour || 'white'
        };
    };
    const colDataStyle = (record) => {
        return {
            ['color']: record.tCardUserHolidayTypeTextColour || 'black'
        };
    };

    const baseUrl = 'TCardUserHolidayType/TCardUserHolidayType_List';

    return (
        <div>
            <BreadCrumbs crumbs={crumbs} />
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <ReportGijgoGrid
                        dataConverter={(res) => ({
                            records: res?.data,
                            total: res?.data[0]?.total
                        })}
                        columns={columns}
                        getUrl={baseUrl}
                        isReload={state.isReload}
                        AddBtn={addButton}
                        setRowStyleOnCondition={true}
                        setRowStyleFunction={rowDataStyle}
                        setColStyleOnCondition={true}
                        setColStyleFunction={colDataStyle}
                    />
                </Grid>
            </Grid>
            {state.showModal ? (
                <DialogComp
                    maxWidth="sm"
                    overflow="auto"
                    title={state.selectedUserHolidayTypeID ? 'Update Holiday Type' : 'Add Holiday Type'}
                    onClose={() => handleClose(false)}
                >
                    <AddUpdateHolidayTypeModal onClose={() => handleClose(true)} holidayTypeID={state.selectedUserHolidayTypeID} />
                </DialogComp>
            ) : null}
        </div>
    );
};
export default HolidayType;
